// PdfStyles.js
import { createTheme } from "@mui/material/styles";

export const pdfTheme = createTheme({
  palette: {
    primary: {
      main: "#1976d2"
    }
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: "8px 12px",
          border: "1px solid #e0e0e0 !important",
          fontSize: "0.875rem",
          "&.MuiTableCell-head": {
            backgroundColor: "#f9fafb !important",
            fontWeight: 500
          }
        }
      }
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          border: "1px solid #e0e0e0",
          marginTop: "16px",
          width: "100%"
        }
      }
    }
  }
});

export const pdfSpecificStyles = {
  tableContainer: {
    width: "100%",
    marginTop: "16px",
    overflow: "visible",
    boxShadow: "none"
  },
  table: {
    width: "100%",
    tableLayout: "fixed",
    borderCollapse: "collapse"
  },
  tableCell: {
    border: "1px solid #e0e0e0 !important",
    padding: "8px 12px !important"
  },
  tableHeaderCell: {
    backgroundColor: "#f9fafb !important",
    fontWeight: "500 !important"
  }
};
